import Axios, { AxiosResponse } from 'axios';
import { errorHandler } from 'services/axios/axiosErrorInterceptor';
import { environment } from 'config/environment';
import { identity } from 'rambda';
import { axiosTokenInterceptor } from 'services/axios/axiosAccesTokenInterceptor';

const apiBaseUrl = environment.apiUrl;

const createBaseAxios = () =>
  Axios.create({
    baseURL: apiBaseUrl,
  });

const createAuthorizedAxios = () =>
  Axios.create({
    baseURL: apiBaseUrl,
  });

export const BaseAxios = createBaseAxios();
export const AuthorizedAxios = createAuthorizedAxios();

// ----------- Helpers -----------
export const flatten = <T>(a: AxiosResponse<T>) => a?.data;

// ----------- BaseAxios interceptors -----------
BaseAxios.interceptors.response.use(identity, errorHandler);

// ----------- AuthorizedAxios interceptors -----------
AuthorizedAxios.interceptors.request.use(axiosTokenInterceptor);
AuthorizedAxios.interceptors.response.use(identity, errorHandler);
